import createErrorHandler from 'utils/createErrorHandler';

function validateBulkUpdateInstructor({
  primaryInstructor,
  contestSbatGroups,
}) {
  const [errors, addError] = createErrorHandler();

  if (!primaryInstructor) {
    addError(
      'primaryInstructor',
      'Select a valid primary instructor to proceed!'
    );
  }

  if (contestSbatGroups?.length > 0) {
    addError('contest', 'Instructors cannot be added in contests!');
  }

  return errors;
}

export default validateBulkUpdateInstructor;
